<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content [formGroup]="form">
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'genericTree.field.name' | transloco }}</mat-label>
      <input matInput formControlName="name" [placeholder]="'genericTree.placeholder.nodeName' | transloco">
      @if (form.get('name')?.hasError('required')) {
      <mat-error>
        {{ 'genericTree.error.nameRequired' | transloco }}
      </mat-error>
      }
    </mat-form-field>

    <div class="toggle-container">
      <mat-slide-toggle formControlName="active">{{ 'genericTree.field.active' | transloco }}</mat-slide-toggle>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'genericTree.action.cancel' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">{{ 'genericTree.action.save' | transloco }}</button>
</mat-dialog-actions>
